import { Grid } from "@material-ui/core";
import { activityStatuses } from "features/activity/activityConsts";
import { useGetMechanicalActivitiesQuery } from "features/activity/activitySlice";
import { useGetClientsQuery } from "features/clients/clientSlice";
import { loadStatuses } from "features/loads/enums";
import { useGetLoadsQuery } from "features/loads/loadsSlice";
import _ from "lodash";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { arrayToObject } from "utils/object-util";
import { GraphLoader } from "../../WorkorderDashboard/GraphLoader";
import WidgetTitle from "../WidgetTitle/WidgetTitle";
import { workorderApprovalStyle } from "./style";
import WorkorderButtons from "./WorkorderList/WorkorderButtons";
import WorkorderList from "./WorkorderList/WorkorderList";

const WorkorderApprovalWidget = ({ loadsOnly = false }) => {
    const classes = workorderApprovalStyle();

    let { data: mechanicalActivities, error: mechanicalActivitiesError, refetch, isFetching: isLoadingMechanicalActivities } = useGetMechanicalActivitiesQuery(undefined, { skip: loadsOnly });
    let { data: loads, error: loadListError, isLoading: isLoadingLoads } = useGetLoadsQuery({});
    let { data: clients, error: clientError, isLoading: isLoadingClients } = useGetClientsQuery(null);
    
    const clientAccounts = _.flatten(clients?.map(c => c.clientAccounts));
    const { dashboardFilters } = useSelector(state => state.fleetManagementDashboardState);
    
    const [isPendingApproval, setIsPendingApproval] = useState(loadsOnly);

    const clientLookup = useMemo(() => arrayToObject(clients), [clients]);
    const clientAccountsLookup = useMemo(() => arrayToObject(clientAccounts), [clientAccounts]);

    const allEntities = [...(mechanicalActivities || []), ...(loads || [])];

    const mappedData = useMemo(() => allEntities?.map(entity => {
        var client = clientLookup?.[entity.clientId];
        var clientAccount = clientAccountsLookup[entity.clientAccountId];
        return {
            ...entity,
            clientName: client?.name + (client?.name != clientAccount?.name ? ": " + clientAccount?.name : ""),
        }
    }), [mechanicalActivities, loads]);

    const filteredData = mappedData?.filter(f => (dashboardFilters.isDefaultAccount? (!dashboardFilters.clientId || dashboardFilters.clientId == f?.clientId) 
    : (!dashboardFilters.clientAccountId || dashboardFilters.clientAccountId == f?.clientAccountId)));

    const pendingApprovalEntities = filteredData?.filter(w => w.activityStatus == activityStatuses.PendingClientApproval || w?.latestStatus === loadStatuses.PENDING_PRICING_APPROVAL) ?? [];
    const flaggedActivities = filteredData?.filter(w => w?.latestFlag) ?? [];

    const loading = isLoadingMechanicalActivities || isLoadingLoads;

    return <Grid container direction="column" className={classes.graphWrapper}>
        <Grid item>
            <WidgetTitle
                title={loadsOnly ? 'Transports Requiring Attention' : 'Work Orders & Transports Requiring Attention'}
                loading={loading}
                info={loadsOnly ? `This widget shows you the transports that require attention. They are pending final pricing approval from the client and you are able to approve them right from this widget.` 
                    : `This widget shows you the work orders and transports that require attention. The first card is a count of Work Orders that were flagged. You can click on them to see what comment the technician left in case there is an action for you, otherwise, the information there is just for you to follow.\nThe second column are the work orders/transports pending final pricing approval from the client before the team starts working on them. You are able to approve them right from this widget.`}
            />
        </Grid>
        <Grid item style={{ height: 300 }}>
            <WorkorderButtons
                isPendingApproval={isPendingApproval}
                setIsPendingApproval={setIsPendingApproval}
                PACount={pendingApprovalEntities?.length}
                NACount={flaggedActivities?.length}
                loadsOnly={loadsOnly}
                pendingLoads={filteredData?.filter(w => w?.latestStatus === loadStatuses.PENDING_PRICING_APPROVAL)} 
            />
            <WorkorderList
                entities={isPendingApproval ? pendingApprovalEntities : flaggedActivities} 
                showActions={isPendingApproval} 
                loadsOnly={loadsOnly}
            />
        </Grid>
        <GraphLoader loading={loading} />
    </Grid>
}

export default WorkorderApprovalWidget;